module.exports = __webpack_public_path__ + "static/img/liveControl-bg1.75bdb0b5.png";